import {createStyles, Theme} from '@material-ui/core/styles'
import {Colors} from 'components/common/useBaseStyle'

const ProductsDetailStyle = (theme: Theme) =>
  createStyles({
    table: {
      position: 'relative',
      minWidth: 880,
      color: 'red',
      '& td': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: 2,
        paddingTop: 6,
        paddingBottom: 6,
        height: 43,
      },
      marginBottom: 20,
    },
    tableHeader: {
      height: 42,
      backgroundColor: Colors.tableHeaderBackground,
      verticalAlign: 'middle',
      borderRadius: 10,
      '& th': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: '1rem',
        fontWeight: 'bold',
      },
    },
    toolBar: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    searchBar: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 8,
      flexWrap: 'wrap',
      marginBottom: 10,
      '& .MuiOutlinedInput-input': {
        padding: 0,
        margin: 12,
      },
      [theme.breakpoints.down('md')]: {
        gap: 4,
      },
    },
    searchSelect: {
      width: 80,
      height: 36,
      fontSize: 13,
    },
    searchSelectV1: {
      width: 110,
      height: 36,
      fontSize: 13,
    },
    searchSelectV2: {
      width: 'fit-content',
      height: 36,
      fontSize: 13,
    },
    searchSelectName: {
      width: 160,
      height: 40,
    },
    flexRight: {
      marginLeft: 'auto',
    },
    headerMax: {
      border: '1px solid rgba(224, 224, 224, 1)',
      padding: 8,
    },
    cellParent: {
      border: '1px solid rgba(224, 224, 224, 1)',
      padding: 8,
      backgroundColor: '#f4f4f7',
    },
    cell: {
      border: '1px solid rgba(224, 224, 224, 1)',
      textAlign: 'center',
      height: 43,
      padding: 8,
    },
    bgItem: {
      backgroundColor: '#f4f4f7',
    },
    fieldRadio: {
      minWidth: 160,
      fontSize: 13,
      color: '#5A6268',
      '& > .MuiRadio-colorSecondary.Mui-checked': {
        color: '#10CFC9 !important',
      },
      '@media (max-width: 1920px)': {
        minWidth: 140,
      },
      '@media (max-width: 1800px)': {
        minWidth: 100,
      },
      '@media (max-width: 1700px)': {
        minWidth: 80,
      },
      '@media (max-width: 1400px)': {
        minWidth: 40,
      },
    },
    fieldRadioV1: {
      minWidth: 100,
      fontSize: 13,
      color: '#5A6268',
      '& > .MuiRadio-colorSecondary.Mui-checked': {
        color: '#10CFC9 !important',
      },
      '@media (max-width: 1920px)': {
        minWidth: 90,
      },
      '@media (max-width: 1800px)': {
        minWidth: 80,
      },
    },
    titleCard: {
      margin: '0px 0 20px',
      fontSize: '1.125rem',
    },
    input: {
      width: '100%',
      border: '1px solid #e0e0e0',
      minHeight: 36,
      textAlign: 'right',
      flex: 1,
      height: 36,
      outline: 'none',
      borderRadius: 4,
      margin: '10px 0',
      padding: '0 10px !important',
    },
    disableText: {
      color: '#a6a6a6',
    },
    select: {
      border: '1px solid rgba(224, 224, 224, 1)',
      '& :before': {
        border: 'none',
      },
      '& :before:hover': {
        border: 'none',
      },
    },
    '.MuiInput-underline:before': {
      border: 'none',
    },
    inputV2: {
      width: 150,
      marginRight: 10,
      border: '1px solid #e0e0e0',
      minHeight: 36,
      textAlign: 'right',
      height: 36,
      borderRadius: 4,
      margin: '5px 0',
      padding: '0 10px !important',
    },
    inputNumber: {
      width: 150,
      marginRight: 10,
      border: '1px solid #e0e0e0',
      minHeight: 36,
      textAlign: 'right',
      height: 36,
      borderRadius: 4,
      margin: '5px 0',
      padding: '0 10px !important',
    },
    inputV3: {
      width: '100%',
      border: '1px solid #e0e0e0',
      minHeight: 80,
      textAlign: 'left',
      padding: 10,
      borderRadius: 4,
      fontSize: 16,
      margin: '5px 0',
      resize: 'none',
      outline: 'none',
    },
    groupRadioSpecial: {
      display: 'flex',
      alignItems: 'center',
    },
    groupRadio: {
      display: 'flex',
      flexDirection: 'row',
    },
    flex: {
      display: 'flex',
    },
    monthlyInstallmentLabel: {
      display: 'flex',
      alignItems: 'center',
      padding: 10,
      marginRight: 0,
      gap: 5,
    },
    p0: {
      padding: 0,
    },
    widthCell: {
      width: '146px',
    },
    itemCell: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 5,
      // padding: 10,
    },
    h30: {
      height: '30px',
    },
    w700: {
      width: 700,
    },
    H1: {
      margin: '50px 0 20px',
      fontSize: '1.125rem',
    },
    paymentMethods: {
      display: 'flex',
      gap: 20,
      alignItems: 'center',
      marginBottom: 20,
    },
    widthsCell: {width: 130, maxWidth: 130, minWidth: 130},
    listBBtn: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 20,
    },
  })

export default ProductsDetailStyle
